<template>
  <q-card
    :style="cssVars"
    class="card q-mx-auto"
    style="max-width: 756px; width: 100%"
  >
    <q-scroll-area
      :thumb-style="{
        background: '#162c479c',
        opacity: 1,
        width: '8px',
        height: '8px',
        borderRadius: '20px',
      }"
      style="width: 756px; height: 100%"
    >
      <div class="row justify-between q-px-md items-center">
        <div style="width: 205px" class="row justify-center">
          <div>
            <q-icon name="fas fa-lightbulb" size="xs" color="accent"> </q-icon>
            <span class="header_text text-accent text-center">
              Articles and Insights
            </span>
          </div>
        </div>

        <div>
          <q-btn
            icon="mdi-close"
            @click="closeDialog"
            flat
            round
            color="grey-6"
          >
          </q-btn>
        </div>
      </div>

      <div class="bg-accent header_text_underline"></div>
      <div class="row banner q-mb-sm" v-if="!loading && data">
        <div class="banner_text">
          <div
            class="row justify-between q-px-xl q-mt-lg text-white small-text"
          >
            <div>
              <span>
                {{ data.created_at | articleCardDate }}
              </span>
            </div>
            <div>{{ data.totalReadMins.toFixed(0) }}mins</div>
          </div>
          <div class="row q-mt-xl" style="margin-left: 60px">
            <div class="big-text text-white">
              {{ data.title }}
            </div>
          </div>
        </div>
        <div>
          <q-img class="image" :src="data.imageUrl"> </q-img>
        </div>
      </div>
      <div class="row" style="padding: 15px 50px 20px 50px">
        <div style="margin-bottom: 10px">
          <span class="text-primary article_body_title">
            Placeholder Text
          </span>
          <br />
          <span class="article_body_author"> by </span>
          <span class="article_body_author_bold"> {{ data.author }}</span>
        </div>
        <div>
          <p
            v-if="data.description"
            v-html="$options.filters.nl2br(data.description)"
          ></p>
        </div>
      </div>
      <div class="solutions_section">
        <div class="row">
          <span class="title"> Suggested solutions to add to your plan </span>
        </div>
        <div class="row q-col-gutter-md q-mt-sm">
          <div
            v-for="(solution, i) in suggestedSolutions"
            :key="i"
            class="col-6"
          >
            <q-card @click="() => {}" flat v-ripple class="solutionCard">
              <div class="row items-center">
                <div>
                  <q-checkbox
                    v-model="solution.selected"
                    @input="(val) => addToList(val, solution)"
                  ></q-checkbox>
                </div>
                <div class="solutionCardTitle">
                  {{ solution.title }}
                </div>
              </div>
            </q-card>
          </div>
        </div>
        <div class="row q-mt-lg">
          <div>
            <q-btn
              :disabled="preview"
              color="accent addToWorkspace_btn"
              no-caps
              @click="adoptSolutions"
              :loading="addingSolutionsLoading"
            >
              <span class="addToWorkspace_btn_text"> Add to workspace </span>
            </q-btn>
          </div>
        </div>
      </div>
      <div class="row justify-between q-py-md q-px-lg items-center">
        <div>
          <span class="footer"> © Oatas {{ new Date().getFullYear() }}</span>
        </div>
        <div>
          <div class="row">
            <!-- <q-btn
              icon="mdi-share-variant"
              color="accent"
              flat
              round
              @click="() => {}"
            >
            </q-btn>
            <q-btn
              icon="fab fa-facebook-square"
              style="color: #4267b2"
              flat
              round
              @click="() => {}"
            >
            </q-btn>
            <q-btn
              icon="fab fa-linkedin"
              flat
              round
              @click="() => {}"
              style="color: #0077b5"
            >
            </q-btn> -->
          </div>
        </div>
      </div>
    </q-scroll-area>
  </q-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    suggestedSolutions: [],
    solutionsToAdd: [],
    addingSolutionsLoading: false,
  }),
  computed: {
    ...mapGetters({
      data: "articles/selectedArticle",
      loading: "articles/listLoading",
      outcomesList: "outcomes/list",
      articlesSolutionsList: "articles/solutions/list",
    }),

    selectedOutcome() {
      if (this.outcomesList.length > 0) {
        let index = this.outcomesList.findIndex(
          (e) => e.id == parseFloat(this.$route.params.id)
        );

        if (index > -1) {
          return this.outcomesList[index];
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    cssVars() {
      if (this.selectedOutcome) {
        let primaryColorFaded = this.selectedOutcome.primaryColor
          ? this.selectedOutcome.primaryColor.split("#")
          : ["", "162c47"];
        let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";
        return {
          "--outcome-primary": this.selectedOutcome.primaryColor
            ? this.selectedOutcome.primaryColor
            : "#162c47",
          "--outcome-secondary": this.selectedOutcome.secondaryColor
            ? this.selectedOutcome.secondaryColor
            : "#162c47",
          "--outcome-tertiary": this.selectedOutcome.tertiaryColor
            ? this.selectedOutcome.tertiaryColor
            : "#162c47",
          "--outcome-primary-faded": primaryColorFadedString,
        };
      } else {
        return {};
      }
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    data: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  methods: {
    init() {
      if (this.data) {
        this.addSelectedAttrToSuggestedSolutions();
      }
    },
    addSelectedAttrToSuggestedSolutions() {
      let newList = [];
      if (this.data) {
        if (this.preview) {
          this.articlesSolutionsList.forEach((e) => {
            newList.push({ ...e, selected: false });
          });
        } else {
          this.data.suggestedSolutions.forEach((e) => {
            newList.push({ ...e, selected: false });
          });
        }
        this.suggestedSolutions = newList;
      }
    },
    addToList(val, solution) {
      if (val) {
        this.solutionsToAdd.push(solution);
      } else {
        this.solutionsToAdd = this.solutionsToAdd.filter(
          (s) => s.id != solution
        );
      }
    },
    async adoptSolutions() {
      this.addingSolutionsLoading = true;
      let result = await this.$store.dispatch(
        "solutions/business/newMass",
        this.solutionsToAdd
      );
      this.solutionsToAdd = [];
      this.addingSolutionsLoading = false;
      this.$forceUpdate();
      if (result.Result == "Success") {
        this.$q.notify({
          position: "top-right",
          type: "positive",
          message: result.Response.Message,
        });
      } else {
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an Error, Please try again later",
        });
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  height: 100vh;
}
.header_text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}
.header_text_underline {
  width: 205px;
  margin-left: 20px;
  height: 4px;
  border-radius: 20px 20px 0px 0px;
}

.banner {
  height: 203px;

  .banner_text {
    width: 445px;
    background-color: $accent;

    .small-text {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
    }
    .big-text {
      font-family: "Montserrat";
      font-style: normal;
      font-weight: 700;
      font-size: 20px;
    }
  }

  .image {
    width: 305px;
  }
}

.article_body_title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
}

.article_body_author {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
}
.article_body_author_bold {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
}

.article_description {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: rgba(22, 44, 71, 0.5);
}

.solutions_section {
  background: #f6f6f6;
  height: 263px;
  width: 754px;
  padding: 30px 40px 30px 40px;
}

.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
}

.footer {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}

.solutionCardTitle {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 11.3746px;
}

.addToWorskpace_btn {
  width: 133.62px;
  height: 34px;
}

.addToWorkspace_btn_text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 9px;
}

.solutionCard:hover {
  background-color: rgb(184, 244, 255);
}
</style>
